module.exports = __webpack_public_path__ + "media/newstyle/images/Google_Play-6d9b2cc6abb54edd34a7b1a96c70d2b9.svg";